import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { connect } from "react-redux";
import { useParams, Navigate } from "react-router-dom";
import { Button, Modal, Form } from "react-bootstrap";

import MainWrapper from "../../MainWrapper";
import { CUSTOMER_LIST_REQUEST } from "../../../_utils/constants/Customer";
import Table from "./estimatesModels/estimateTable";
import { CUSTOMER_ESTIMATES_REQUEST, PRICING_CONTRACT_MISSING_KIT_REQUEST, EXPORT_ESTIMATION_COST_REQUEST, SAVE_ESTIMATES_REQUEST } from "../../../_utils/constants/PricingContract";
import "../../../assets/css/estimates.css";
// import standardinteriorslogo from "../../../assets/images/standardinteriors2.png";
// import StandardLogoLV from "../../../assets/images/Standard-Logo-LV.png";
// import StandardLogoAZ from "../../../assets/images/Standard-Logo-AZ.png";
// import StandardLogoCO from "../../../assets/images/Standard-Logo-CO.png";

const Estimates = ({
  auth: { auth, isAuthenticated },
  customerInfo: { customerList, isLoading },
  pricingContract: { estimates, missingKitsInContract, isExporting, isSavingEstimates },
  fetchCustomerList,
  fetchCustomerEstimates,
  fetchMissingKitInContract,
  exportEstimationCost,
  saveEstimates,
}) => {
  const { id, dataType='default' } = useParams();
  const [customerInfo, setCustomerInfo] = useState({});
  const [estimatesData, setEstimatesData] = useState([]);
  const [imageUrl, setImageUrl] = useState();
  const [missingKitData, setMissingKitData] = useState([]);
  const [hasEstimateChanges, setHasEstimateChanges] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printMode, setPrintMode] = useState('all-default');
  const [selectedPrintVariant, setSelectedPrintVariant] = useState('');
  const [printTrigger, setPrintTrigger] = useState(0);

  useEffect(() => {
    if (isAuthenticated) {
      fetchCustomerList(
        auth[0].token,
        "asc",
        1,
        1,
        { contactInfoId: id },
        auth[0].userId,
        false,
        false,
        false
      );
      fetchCustomerEstimates(auth[0].token, id, dataType);
      fetchMissingKitInContract(auth[0].token, id)
    }
    if (!isAuthenticated) return <Navigate to="/login" />;
  }, [auth, isAuthenticated]);

  useEffect(() => {
    if (estimates.length > 0) {
      const sorted = estimates.sort((a, b) => {
        // Sort alphabetically by floorPlanName
        if (a.floorPlanName.toLowerCase() < b.floorPlanName.toLowerCase()) return -1;
        if (a.floorPlanName.toLowerCase() > b.floorPlanName.toLowerCase()) return 1;

        // For same floorPlanName, put isDefaultVariant=true first
        return b.isDefaultVariant - a.isDefaultVariant;
      });

      setEstimatesData(sorted);
    }
  }, [estimates]);

  useEffect(() => {
    if (customerList.length > 0) {
      setImageUrl(customerList[0].storeLogo)
      setCustomerInfo(customerList[0]);
    }
  }, [customerList]);

  useEffect(() => {
    if (missingKitsInContract && missingKitsInContract.length > 0) {
      let missingKitsData = missingKitsInContract.map(value => value?.privateName).filter(Boolean)
      setMissingKitData(missingKitsData)
    }
  }, [missingKitsInContract])

  const componentRef = useRef();
  const tableRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: '@media print { .print-hide { display: none !important; } .no-print { display: none !important; } input, textarea, select { border: 0 !important; outline: none !important; box-shadow: none !important; } }',
  });

  useEffect(() => {
    if (printTrigger > 0) {
      handlePrint();
    }
  }, [printTrigger]);

  const executePrint = () => {
    if (printMode === 'individual' && !selectedPrintVariant) return;
    setShowPrintModal(false);
    setPrintTrigger(t => t + 1);
  };

  const handleCostExport = () => {
    exportEstimationCost(auth[0].token, id, dataType);
  };

  const handleSave = () => {
    if (tableRef.current) {
      const payload = tableRef.current.buildSavePayload();
      saveEstimates(auth[0].token, auth[0].userId, id, payload);
    }
  };

  return (
    <MainWrapper className="page-print-container">
      {estimatesData.length > 0 && (<><Button onClick={() => setShowPrintModal(true)}>Print this out!</Button>  <Button onClick={handleCostExport} disabled={isExporting}>{isExporting ? 'Processing...' : 'Cost Export'}</Button>  <Button onClick={handleSave} disabled={isSavingEstimates || !hasEstimateChanges}>{isSavingEstimates ? 'Saving...' : 'Save'}</Button></>)}
      <div
        ref={componentRef}
        className="print-container"
        style={{ margin: "0", padding: "0" }}
      >
        <img src={imageUrl} alt="Standard Logo" className="logo" />
        <h1>Estimate Prepared For</h1>
        <h3>{customerInfo.shipToPropertyName}</h3>
        <p>Estimates valid for 30 days</p>
        {(customerInfo?.viableSeamsFloorPlans && customerInfo?.viableSeamsFloorPlans.length > 0) ?
          <div style={{ color: "red", margin: "0", padding: "0", "font-weight":"500", "font-size": "35px" }}>* Floorplan should be reviewed by estimating staff prior to issuing to customer. </div> : null
        }
        {(missingKitData && missingKitData.length > 0) ?
          <div style={{ color: "red", margin: "0 0 15px 0", padding: "0", "font-weight":"500", "font-size": "35px" }}>* Product specific kit for {missingKitData.join()} has been created. Update the contract for new orders. </div> : null
        }
        <Table ref={tableRef} estimatesData={estimatesData} isLoading={isLoading} customerInfo={customerInfo} printMode={printMode} printVariantId={selectedPrintVariant} onHasChanges={setHasEstimateChanges}/>
        <div className="pagebreak" />
        <p>
          * All pricing is subject to labor minimum charges and/or trip charges.
          Pricing is good for 30 days after receipt and is subject to change.
        </p>
        <p>
          Change Orders: Price includes standard floor preparation, defined as
          light skimcoating of hairline cracks or small recesses (less than
          2&quot; in diameter and 1/2&quot; in depth). Anything above is
          atypical and will incur additional floor prep costs. All changes
          /additional costs will be quoted for approval prior to commencement of
          additional work. Price does not include moving furniture, toilets,
          appliances, or modifications to any other unit finishes, electronics,
          or plumbing. Furniture, toilet, or appliance moving must be requested
          before day of install, and is limited to specific items. Additional
          costs will be added to order. Warranty: Standard Interiors warrants
          all labor for a period of one year, with the exception of LVT plank
          installations that are warranted for two years. All materials are
          warranted by the manufacturer.
        </p>
      </div>
      <Modal show={showPrintModal} onHide={() => setShowPrintModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Print Options</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {[
              { value: 'summary',       label: 'Print Just Summary' },
              { value: 'all-default',   label: 'Print All Default Layouts' },
              { value: 'all-alternate', label: 'Print All Alternate Layouts' },
              { value: 'individual',    label: 'Print Individual Layout (select one)' },
            ].map(opt => (
              <Form.Check
                key={opt.value}
                type="radio"
                id={`print-mode-${opt.value}`}
                name="printMode"
                label={opt.label}
                value={opt.value}
                checked={printMode === opt.value}
                onChange={() => setPrintMode(opt.value)}
                className="mb-2"
              />
            ))}
            {printMode === 'individual' && (
              <Form.Select
                value={selectedPrintVariant}
                onChange={e => setSelectedPrintVariant(e.target.value)}
                className="mt-2"
              >
                <option value="">-- Select a Layout --</option>
                {estimatesData.map(fp => (
                  <option key={fp.variantId} value={String(fp.variantId)}>
                    {fp.floorPlanName}{fp.variantName ? ` (${fp.variantName})` : ''}{fp.isDefaultVariant ? ' [Default]' : ' [Alternate]'}
                  </option>
                ))}
              </Form.Select>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPrintModal(false)}>Cancel</Button>
          <Button
            variant="primary"
            onClick={executePrint}
            disabled={printMode === 'individual' && !selectedPrintVariant}
          >
            Print
          </Button>
        </Modal.Footer>
      </Modal>
    </MainWrapper>
  );
};

const mapStateToProps = ({ auth, customerInfo, pricingContract }) => {
  return {
    auth,
    customerInfo,
    pricingContract,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchCustomerList: (
      token,
      sort,
      page,
      paginate,
      listParamState,
      userId,
      salesPersonId,
      GrpPcId,
      isChecked
    ) =>
      dispatch({
        type: CUSTOMER_LIST_REQUEST,
        token,
        sort,
        page,
        paginate,
        listParamState,
        userId,
        salesPersonId,
        GrpPcId,
        isChecked,
      }),
    fetchCustomerEstimates: (token, contactInfoId, dataType) =>
      dispatch({ type: CUSTOMER_ESTIMATES_REQUEST, token, contactInfoId, dataType }),
    fetchMissingKitInContract: (token, contactInfoId) =>
      dispatch({ type: PRICING_CONTRACT_MISSING_KIT_REQUEST, token, contactInfoId }),
    exportEstimationCost: (token, contactInfoId, dataType) =>
      dispatch({ type: EXPORT_ESTIMATION_COST_REQUEST, token, contactInfoId, dataType }),
    saveEstimates: (token, userId, contactInfoId, payload) =>
      dispatch({ type: SAVE_ESTIMATES_REQUEST, token, userId, contactInfoId, payload }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Estimates);
